var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('myheader'),_c('router-view',{on:{"loaded":_vm.onRouteActivated}}),(_vm.isRouteLoaded)?_c('myfooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }